import * as React from 'react';

import { RegionSelect } from '../../components/RegionSelect';
import { useSelector } from 'react-redux';

import { GeoLocationModalContainer } from '../GeoLocationModalContainer';
import { selectFilters } from '../../../common/selectors/filters';

interface IRegionSelectContainerProps {
  modalOpen?: boolean;
  needReload?: boolean;
}

export const RegionSelectContainer: React.FC<IRegionSelectContainerProps> = ({
  modalOpen = false,
  needReload = false,
}) => {
  const [isOpen, setIsOpen] = React.useState(modalOpen);
  const filters = useSelector(selectFilters);

  const handlePopup = React.useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  return (
    <RegionSelect
      regionName={filters.region.displayName}
      popupIsOpen={isOpen}
      openPopup={handlePopup}
      geoModal={<GeoLocationModalContainer reload={needReload} modalIsOpen={isOpen} handleOpenModal={handlePopup} />}
    />
  );
};
